const convertCentimetersToInches = (cm: number) => Math.round(cm / 2.54);
const convertInchesToCentimeters = (inch: number) => Math.round(inch * 2.54);
const convertFeetToInches = (feet: number) => Math.round(feet * 12);
export { convertCentimetersToInches, convertFeetToInches, convertInchesToCentimeters };
